<template>
    <section class="artist">
          <div class="block">
            <div class="artistblock"><svg class="svg100" ratio="0.25" fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 480"><title>artist_white</title><polygon points="0 0 1920 480 0 480 0 0" /></svg></div>
          </div>
          <div class="main">
            <div class="bookmark"><img src="../../asset/svg/bookmark/v/artist.svg" alt="多寶創作人"></div>
            <div class="txtcontent nonefordesktop strip">
              <h2 class="wow1"><img src="../../asset/svg/title/artist1.svg" alt="認識多寶創作人"></h2>
              <p class="wow2">「純粹、專注、原創」<br>因為有這些特質，他們為世界帶來不一樣的美麗</p>
              <!-- artist description txt -->
              <h4 class="wow3">
                <span class="work_0 show">蒙娜麗莎對我微笑</span>
                <span class="work_1">美是一種本能</span>
                <span class="work_2">無敵萬能車</span>
                <span class="work_3">優遊自在的空間</span>
                <span class="work_4">小小色彩大大天空</span>
                <span class="work_5">想像世界畫不停手</span>
                <span class="work_6">簡單美</span>
                <span class="work_7">人之初</span>
                <span class="work_8">我的思緒與螺旋槳</span>
              </h4>
            </div>
            <div class="work wow4">
              <div class="artistname">
                <!-- artist name -->
                <img src="../../img/artist/name01.svg" alt="柏均" class="name_0 show">
                <img src="../../img/artist/name02.svg" alt="佳瑄" class="name_1">
                <img src="../../img/artist/name03.svg" alt="健騰" class="name_2">
                <img src="../../img/artist/name04.svg" alt="博為" class="name_3">
                <img src="../../img/artist/name05.svg" alt="祐綸" class="name_4">
                <img src="../../img/artist/name06.svg" alt="瑩芷" class="name_5">
                <img src="../../img/artist/name07.svg" alt="樹緯" class="name_6">
                <img src="../../img/artist/name08.svg" alt="怡初" class="name_7">
                <img src="../../img/artist/name09.svg" alt="廷瑋" class="name_8">
                <img src="../../img/artist/name_bg.png" class="name_bg">

              </div>

                <ul class="worklist wow1">
                  <!-- artist work -->
                  <li class="swiper-slide">
                    <a href="javascript:void(0)" v-on:click="goArt()" class="workpic">
                      <img src="../../img/artist/indexpic01.jpg" alt="柏均">
                    </a>
                  </li>
                  <li class="swiper-slide">
                    <a href="javascript:void(0)" v-on:click="goArt()" class="workpic">
                      <img src="../../img/artist/indexpic02.jpg" alt="佳瑄">
                    </a>
                  </li>
                  <li class="swiper-slide">
                    <a href="javascript:void(0)" v-on:click="goArt()" class="workpic">
                      <img src="../../img/artist/indexpic03.jpg" alt="健騰">
                    </a>
                  </li>
                  <li class="swiper-slide">
                    <a href="javascript:void(0)" v-on:click="goArt()" class="workpic">
                      <img src="../../img/artist/indexpic04.jpg" alt="博為">
                    </a>
                  </li>
                  <li class="swiper-slide">
                    <a href="javascript:void(0)" v-on:click="goArt()" class="workpic">
                      <img src="../../img/artist/indexpic05.jpg" alt="祐綸">
                    </a>
                  </li>
                  <li class="swiper-slide">
                    <a href="javascript:void(0)" v-on:click="goArt()" class="workpic">
                      <img src="../../img/artist/indexpic06.jpg" alt="瑩芷">
                    </a>
                  </li>
                  <li class="swiper-slide">
                    <a href="javascript:void(0)" v-on:click="goArt()" class="workpic">
                      <img src="../../img/artist/indexpic07.jpg" alt="樹緯">
                    </a>
                  </li>
                  <li class="swiper-slide">
                    <a href="javascript:void(0)" v-on:click="goArt()" class="workpic">
                      <img src="../../img/artist/indexpic08.jpg" alt="怡初">
                    </a>
                  </li>
                  <li class="swiper-slide">
                    <a href="javascript:void(0)" v-on:click="goArt()" class="workpic">
                      <img src="../../img/artist/indexpic09.jpg" alt="廷瑋">
                    </a>
                  </li>
                </ul>
              
              
              <!-- <ul class="worktab swiper-pagination">
               
              </ul> -->
              <a data-href="/#/artist1" class="arrow_into" v-on:click="goArt()">
              <svg class="arrowtop" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.86 18.28"><title>top</title><path d="M33.38,15.63,16,.39a1.57,1.57,0,0,0-2.58,1.15Q7.08,8.78.42,15.73c-1.33,1.38.77,3.49,2.1,2.1Q9.12,11,15.37,3.8l15.9,13.94C32.71,19,34.82,16.9,33.38,15.63Z" /></svg>
              <svg class="arrowbg"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.86 93.28"><title>btn</title><path d="M0,48.67C-.06,29,12.8,9.5,31,1.79c12.47-5.27,33.3,1.68,39.81,13.45C73.66,20.35,78,24,82.3,27.59c3,2.52,4.79,5.39,4.3,9.48-.39,3.29,1,6.16,2.46,9a15.11,15.11,0,0,1,.18,14c-12.18,25.24-30,34.78-54.36,33a16,16,0,0,1-8.06-2.36C11.93,80.51,0,68.37,0,48.67Z" /></svg></a>
            </div>
            <div class="txtcontent noneform strip">
              <h2 class="wow1"><img src="../../asset/svg/title/artist1.svg" alt="認識多寶創作人"></h2>
              <p class="wow2">「純粹、專注、原創」<br>因為有這些特質，他們為世界帶來不一樣的美麗</p>
               <h4 class="wow3">
                <span class="work_0 show">蒙娜麗莎對我微笑</span>
                <span class="work_1">美是一種本能</span>
                <span class="work_2">無敵萬能車</span>
                <span class="work_3">優遊自在的空間</span>
                <span class="work_4">小小色彩大大天空</span>
                <span class="work_5">想像世界畫不停手</span>
                <span class="work_6">簡單美</span>
                <span class="work_7">人之初</span>
                <span class="work_8">我的思緒與螺旋槳</span>
              </h4>
            </div>
          </div>
        </section>

</template>

<script>
  // import Swiper from 'swiper'
  import 'slick-carousel'
  export default {
    updated:function(){
      console.log('update');
    },
    mounted:function(){
      var $this = this;
      var $all_work_title=$('.txtcontent h4 span');
      var $all_name=$('.artistname img');
      // $(".worklist").slick('unslick');

      $(".worklist").slick({
        initialSlide:0,
        dots: true,
        autoplay: true,
        // autoplay: false,
        autoplaySpeed: 4000,
        infinite: false,
        speed: 800,
        vertical:true,
        arrows: false,
        pauseOnHover:false,
        pauseOnDotsHover:false,
        verticalSwiping:true,
        appendDots:'.work',
        responsive: [{
            breakpoint: 1100,
            settings: {
              vertical:false,
              verticalSwiping:false,
            }
          }]
      });
      // console.log('define');
      $('.worklist').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        // console.log(slick);
        $all_work_title.removeClass('show');
        $all_name.removeClass('show');
        $this.ani(nextSlide);
        $('.work_'+currentSlide+',.name_'+currentSlide).addClass('trans');

      });
      $('.worklist').on('afterChange', function(event, slick, currentSlide, nextSlide){
          $all_work_title.removeClass('trans');
          $all_name.removeClass('trans');
      });

      
    },
    beforeDestroy:function(){
        $('.worklist').off('beforeChange');
        $('.worklist').off('afterChange');
            
    },
    methods:{
      ani:function(act_ele){
        setTimeout(function(){
          $('.name_'+act_ele+', .work_'+act_ele).addClass('show');
          var goArtist=act_ele+1;
          $('.arrow_into').attr('data-href','/#/artist'+goArtist);
        },300)
      },
      
      goArt:function(){
        var where = $('.arrow_into').attr('data-href');
        $('.worklist').off('beforeChange');
        $('.worklist').off('afterChange');
        window.location=$('.arrow_into').attr('data-href');
        gaclick('btn_artist_enter')
      }
    }
  }
</script>
<style>
    @import 'https://cdn.jsdelivr.net/jquery.slick/1.6.0/slick.css';
</style>


// WEBPACK FOOTER //
// Artist.vue?4b73ccc3